import { useQueryParams } from 'use-query-params'

import { DashArrayParam } from '../../../../../utils/useQueryParams'
import {
    ConversationsFiltersCategoriesEnum,
    ConversationsFiltersEnum,
} from '../ConversationsFilters'

import OtherCategory from './OtherCategory/OtherCategory'

import styles from './conversations-filters-options.module.scss'

interface IConversationsFiltersOptionProps {
    category: ConversationsFiltersCategoriesEnum
    filtersOptions: {
        intents: string[]
        entities: string[]
        actions: string[]
    }
}

function ConversationsFiltersOptions(props: IConversationsFiltersOptionProps) {
    const { category, filtersOptions } = props

    const [query, setQuery] = useQueryParams({
        [ConversationsFiltersEnum.ENTITIES]: DashArrayParam,
        [ConversationsFiltersEnum.INTENTS]: DashArrayParam,
        [ConversationsFiltersEnum.ACTIONS]: DashArrayParam,
    })

    const handleOptionChange = (selectedOptions: string[], option: string) => {
        const clonedSelectedOptions = structuredClone(selectedOptions) || []

        if (clonedSelectedOptions.includes(option)) {
            const index = clonedSelectedOptions.indexOf(option)
            clonedSelectedOptions.splice(index, 1)
            setQuery({
                [category]: clonedSelectedOptions.length
                    ? clonedSelectedOptions
                    : null,
            })
            return
        }

        clonedSelectedOptions?.push(option)
        setQuery({ [category]: clonedSelectedOptions })
    }

    const renderCategory = () => {
        if (category === ConversationsFiltersCategoriesEnum.OTHER) {
            return <OtherCategory />
        }

        const selectedOptions = query[category] as string[]

        return filtersOptions[category].map((option) => (
            <label
                key={option}
                className={styles.conversationsFiltersOptions__label}
            >
                <input
                    type="checkbox"
                    checked={selectedOptions?.includes(option)}
                    onChange={() => handleOptionChange(selectedOptions, option)}
                />
                {option}
            </label>
        ))
    }

    return (
        <div className={styles.conversationsFiltersOptions}>
            {renderCategory()}
        </div>
    )
}

export default ConversationsFiltersOptions
